global._ = {
  fromPairs: (arr) => arr.reduce((acc, val) => (acc[val[0]] = val[1], acc), {}),
  toPairs: Object.entries,
  merge: require('lodash/merge'),
  map: require('lodash/map'),
  flatten: (arr) => arr.reduce((a, b) => a.concat(b), []),
  clone: require('lodash/clone'),
  isNil: require('lodash/isNil'),
  isEmpty: require('lodash/isEmpty'),
  isNumber: require('lodash/isNumber'),
  isArray: require('lodash/isArray'),
  isFinite: require('lodash/isFinite'),
  isEqual: require('lodash/isEqual'),
  find: require('lodash/find'),
  last: (arr) => [].concat(arr).pop(),
  first: (arr) => [].concat(arr).shift(),
  min: require('lodash/min'),
  minBy: require('lodash/minBy'),
  maxBy: require('lodash/maxBy'),
  orderBy: require('lodash/orderBy'),
  sumBy: require('lodash/sumBy'),
  groupBy: require('lodash/groupBy'),
  unionBy: require('lodash/unionBy'),
  differenceWith: require('lodash/differenceWith'),
  compact: (arr) => arr.filter(x => !!x),
  round: require('lodash/round'),
  startsWith: require('lodash/startsWith'),
  remove: require('lodash/remove'),
  unset: require('lodash/unset'),
  uniq: (arr) => [...new Set(arr)],
  take: require('lodash/take'),
  takeRight: require('lodash/takeRight'),
  capitalize: require('lodash/capitalize'),
  truncate: require('lodash/truncate'),
  omit: require('lodash/omit'),
  debounce: require('lodash/debounce')
}

require('requestidlecallback-polyfill')

global.$ = global.jQuery = require('jquery')
global.Cookies = require('js-cookie')

global.uuidV4 = require('uuid/v4')
global.Popper = require('popper.js').default
global.Sortable = require('sortablejs').default
global.log = require('enhanced-log') // http: //broadsw0rd.github.io/enhanced-log/
global.Vue = require('vue').default
global.Vuex = require('vuex').default
global.VueRouter = require('vue-router').default

global.HMDeferMixin = function(count = 100) {
  return {
    data(){
      return { displayPriority: 0 }
    },

    mounted() { this.runDisplayPriority() },

    methods: {
      runDisplayPriority(){
        const step = () => {
          requestAnimationFrame(() => {
            this.displayPriority++
            if (this.displayPriority < count) {
              step()
            }
          })
        }
        step()
      },

      defer(priority) {
        return this.displayPriority >= priority
      }
    }
  }
}

// https://github.com/DVLP/localStorageDB
// // Setting values
// ldb.set('nameGoesHere', 'value goes here');
// // or
// ldb.set('nameGoesHere', 'value goes here', function(){
//   console.log("Data is successfully written to the disk.")
// });

// // Getting values - callback is required because the data is being retrieved asynchronously:
// ldb.get('nameGoesHere', function (value) {
//   console.log('And the value is', value);
// });

// // Deleting one value (callback optional)
// ldb.delete('nameGoesHere', () => console.log('Value deleted'));

// // List all keys
// ldb.list(function(list) {
//   console.log('List of keys', list)
// });

// // Get all keys and values
// ldb.getAll(function(entries) {
//   console.log('All values', entries)
// });

// // Clear everything (callback optional)
// ldb.clear(function() {
//   console.log('Storage cleared')
// });
!function(){var s,c,e="undefined"!=typeof window?window:{},t=e.indexedDB||e.mozIndexedDB||e.webkitIndexedDB||e.msIndexedDB;"undefined"==typeof window||t?((t=t.open("ldb",1)).onsuccess=function(e){s=this.result},t.onerror=function(e){console.error("indexedDB request error"),console.log(e)},t={get:(c={ready:!(t.onupgradeneeded=function(e){s=null,e.target.result.createObjectStore("s",{keyPath:"k"}).transaction.oncomplete=function(e){s=e.target.db}}),get:function(e,t){s?s.transaction("s").objectStore("s").get(e).onsuccess=function(e){e=e.target.result&&e.target.result.v||null;t(e)}:setTimeout(function(){c.get(e,t)},50)},set:function(t,n,o){if(s){let e=s.transaction("s","readwrite");e.oncomplete=function(e){"Function"==={}.toString.call(o).slice(8,-1)&&o()},e.objectStore("s").put({k:t,v:n}),e.commit()}else setTimeout(function(){c.set(t,n,o)},50)},delete:function(e,t){s?s.transaction("s","readwrite").objectStore("s").delete(e).onsuccess=function(e){t&&t()}:setTimeout(function(){c.delete(e,t)},50)},list:function(t){s?s.transaction("s").objectStore("s").getAllKeys().onsuccess=function(e){e=e.target.result||null;t(e)}:setTimeout(function(){c.list(t)},50)},getAll:function(t){s?s.transaction("s").objectStore("s").getAll().onsuccess=function(e){e=e.target.result||null;t(e)}:setTimeout(function(){c.getAll(t)},50)},clear:function(t){s?s.transaction("s","readwrite").objectStore("s").clear().onsuccess=function(e){t&&t()}:setTimeout(function(){c.clear(t)},50)}}).get,set:c.set,delete:c.delete,list:c.list,getAll:c.getAll,clear:c.clear},e.ldb=t,"undefined"!=typeof module&&(module.exports=t)):console.error("indexDB not supported")}();
